"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Set the given value to the given key
 * The key is a dot.notation syntax
 *
 * @param  {ObjectInterface} object
 * @param  {string} key
 * @param  {any} value
 * @returns {ObjectInterface}
 */
function set(object, key, value) {
    if (!key.includes('.')) {
        object[key] = value;
        return object;
    }
    var keys = key.split('.'), currentObject = object;
    for (var i = 0; i < keys.length; i++) {
        var key_1 = keys[i];
        if (i + 1 == keys.length) {
            currentObject[key_1] = value;
        }
        else {
            if (typeof currentObject[key_1] == 'undefined') {
                currentObject = currentObject[key_1] = {};
            }
            else {
                currentObject = currentObject[key_1];
            }
        }
    }
    return object;
}
exports.default = set;
//# sourceMappingURL=set.js.map